// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2inBu","container":"styles_container__Zorhg","title":"styles_title__3M1yh","wrapper":"styles_wrapper__2Vmza","answer":"styles_answer__34tPH"};